import React, { useContext, useEffect } from 'react';
import { Container } from "reactstrap";
import { AuthContext } from "../../context/AuthContext";
import Header from "../../components/Headers/Header";
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import TableCustomerRoutine from '../../components/TableCustomerRoutine/TableCustomerRoutine';

const RoutineCustomerPage = () => {
  const { objUserTk } = useContext(AuthContext); 

  useEffect(() => {
  }, []);

  return (
    <>
      <LoadingSpinner />
      <Header />
      <AdminNavbar 
        brandText={"Tarefas fiscais"}
        search={false}
        titleSearch={""}
      />

      <Container className="mt-4">
        <TableCustomerRoutine />
      </Container>
    </>
  );
};

export default RoutineCustomerPage;